export const IS_GOOGLE_SSO_ENABLED = false;
export const IS_OIDC_SSO_ENABLED = false;
export const OIDC_PROVIDER_LABEL = 'OIDC';
export const PASSKEY_TIMEOUT = 60000;
export const MAXIMUM_PASSKEYS = 50;
